import React, { useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';

const PaperComponent = (props) => {
  const nodeRef = React.useRef(null);
  const [draggablePosition, setPosition] = useState({ x: (window.innerWidth - props.size.width) / 4, y: 20});

  useEffect(() => {
    setPosition(props.draggablePosition);
  }, [props.draggablePosition])

  
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      // defaultPosition={defaultPosition}
      bounds="#draggable-bound"
      nodeRef={nodeRef}
      position={draggablePosition}
      onDrag={(e, data) => {
        setPosition({ x: data.x, y: data.y })
      }}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}

export default PaperComponent;